import { render, staticRenderFns } from "./FuxianTwoTicket.vue?vue&type=template&id=d0e31ce0"
import script from "./FuxianTwoTicket.vue?vue&type=script&lang=js"
export * from "./FuxianTwoTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports